import { Browser } from '@capacitor/browser';
import { DESKTOP_REDIRECT_URL, MOBILE_REDIRECT_URI } from '../utils/urlUtils';

export function DesktopBrowser() {
    window.location.replace(DESKTOP_REDIRECT_URL + "")
}

const openCapacitorSite = async (url: string) => {
    await Browser.open({ url: url, presentationStyle: 'popover', toolbarColor: '#081D37' });
};

export async function MobileBrowser() {
    window.location.href.split("/")[3] !== "mobileAuth" && openCapacitorSite(MOBILE_REDIRECT_URI + "")
    !window.location.href.includes("code") && openCapacitorSite(MOBILE_REDIRECT_URI + "")
};